import { Fragment, forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { MonthlyReportFormContext } from "../context/MonthlyReportFormContext";
import styles from './MonthlyReportBankStatement.module.scss';
import { Form, FormSpy } from "react-final-form";
import arrayMutators from 'final-form-arrays'
import { findFirstErrorField, setFieldTouchedMutator } from "../../../components/functions/utilities";
import { FieldArray } from "react-final-form-arrays";
import BankStatements from "../../Underwriting/UploadDocuments/BankStatements";
import { ApplicationContextType, MonthlyReportSteps } from "../../../interfaces/interfaces";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { RiAddFill as AddIcon } from 'react-icons/ri'
import { getInitialBankStatementDetails } from "../../Underwriting/context/UnderwritingFormContext";
import { bankStatementValidator, sanitizeArrayErrors } from "./bankStatementHelper";
import { useSearchParams } from "react-router-dom";

type Props = {
  setFormPristine: (value: boolean) => void,
}

const MonthlyReportBankStatement = forwardRef(({ setFormPristine }: Props, ref) => {
  const { formData, setFormData, setStepValidity, formStepsValidity, underwritingFileJobs, statementAnalysisJobs } = useContext(MonthlyReportFormContext);
  const [deleteFileKeys, setDeleteFileKeys] = useState([]);
  const [newUploadedDocIds, setNewUploadedDocIds] = useState<number[]>([]);
  const [deleteDocIds, setDeleteDocIds] = useState<number[]>([]);
  const formRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();


  useEffect(() => {
    // console.log('params', params);
    const showError = searchParams.get('error');
    if (showError == "true") {
      formRef?.current?.submit();
      scrollToFirstError();
    }
  }, [searchParams])


  useImperativeHandle(ref, () => ({
    submitForm: () => {
      return new Promise((resolve) => {
        formRef.current.submit();
        console.log("pristine", formRef?.current?.getState())
        if (!formStepsValidity[MonthlyReportSteps.bankStatement]) {
          scrollToFirstError();
          resolve({ success: false, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine, deleteDocIds, newDocIds: newUploadedDocIds, })
        } else {
          // deleteFileKeysOnSubmit();
          resolve({ success: true, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine, deleteDocIds, newDocIds: newUploadedDocIds, })
        }
      })
    }
  }), [formStepsValidity, deleteDocIds, newUploadedDocIds]);

  const onAddAccountScroll = (divId: string) => {
    const element = document.getElementById(divId);
    element?.scrollIntoView({ behavior: 'smooth' });
  }

  const scrollToFirstError = () => {
    try {

      const formState = formRef.current.getState();
      const { errors } = formState;

      // console.log('form state', formState);
      // console.log('formState', formState)
      const firstErrorField = findFirstErrorField(errors);
      // console.log('firstErrorField', firstErrorField);
      const errorField = document.querySelector(`[name="${firstErrorField}"]`) ?? document.getElementById(`${firstErrorField}`);
      console.log('errorField', errorField);
      if (errorField) {
        errorField.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.log('error', error)
    }
  };



  return (
    <div className={styles.rootContainer}>
      <Form
        initialValues={formData}
        mutators={{
          ...arrayMutators,
          setFieldTouched: setFieldTouchedMutator
        }}
        onSubmit={(values) => {
          return {};
        }}
        validate={(values) => {
          const { errors } = bankStatementValidator(values, underwritingFileJobs, statementAnalysisJobs, ApplicationContextType.monthlyReport);
          console.log('bank statement errors', errors);
          const sanitizedErrors = sanitizeArrayErrors(errors);
          console.log('sanitizedErrors', sanitizedErrors);
          return {
            bankStatements: sanitizedErrors,
          }
        }}
        render={({ values, handleSubmit, form }) => {
          formRef.current = form;
          return (
            <form className={styles.formWrapper} onSubmit={handleSubmit}>
              <FormSpy subscription={{ valid: true, pristine: true }} onChange={(state) => {
                // console.log('formState', state)
                // formStepsValidityRef.current[UnderwritingSteps.company] = !state.valid;
                setFormPristine(state.pristine)
                console.log('state.valid', state.valid)
                setStepValidity(MonthlyReportSteps.bankStatement as any, state.valid)
              }} />
              <div className={styles.formRootContainer}>
                <div className={styles.sectionContainer}>
                  <div className={styles.sectionTitleContainer}>
                    <div className={styles.sectionTitle}>
                      Bank Statement
                    </div>
                    <div className={styles.sectionSubTitle}>
                      Upload statements for all your bank accounts.
                    </div>
                  </div>
                </div>
                <div className={styles.sectionFieldsContainer}>
                  <FieldArray name="bankStatements">
                    {({ fields }) => {
                      return (
                        <>
                          {fields.map((fieldName, fieldIndex) => {
                            return (
                              <Fragment key={fields.value[fieldIndex]?.statementJobId ?? fieldName}>
                                <BankStatements
                                  fieldName={fieldName}
                                  fieldIndex={fieldIndex}
                                  deleteFileKeys={deleteFileKeys}
                                  setDeleteFileKeys={setDeleteFileKeys}
                                  newUploadedDocIds={newUploadedDocIds}
                                  setNewUploadedDocIds={setNewUploadedDocIds}
                                  deleteDocIds={deleteDocIds}
                                  setDeleteDocIds={setDeleteDocIds}
                                  contextType={ApplicationContextType.monthlyReport}
                                  stepType={MonthlyReportSteps.bankStatement}
                                />
                                {fieldIndex != fields.length - 1 ? <div className={styles.separator}></div> : null}
                              </Fragment>
                            )
                          })}
                          <div className={styles.addBtnActionContainer}>
                            <div>
                              <MeritoButton size='md2' type='secondary-1' icon={<AddIcon />} btnText={"Add Another Account"} onClick={() => {
                                const currentLength = fields.length;
                                const initialBankStatementDetails = getInitialBankStatementDetails();
                                fields.push(initialBankStatementDetails)
                                setTimeout(() => {
                                  onAddAccountScroll(`account_${currentLength}`)
                                }, 100);
                              }} />
                            </div>
                          </div>
                        </>
                      )
                    }}
                  </FieldArray>
                </div>
              </div>
            </form>
          )
        }}
      />
    </div>
  );
});

export default MonthlyReportBankStatement

